<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="8.990234375"
    height="8"
    viewBox="0 0 8.990234375 8"
  >
    <g>
      <g
        transform="matrix(0.7071067690849304,-0.7071067690849304,0.7071067690849304,0.7071067690849304,-2.538394130882807,1.8717743532033637)"
      >
        <path
          d="M5.690234375,4L5.690234375,7Q5.690234375,7.70416,5.192314375,8.202079999999999Q4.694394375,8.7,3.990234375,8.7L0.990234375,8.7Q0.921290375,8.7,0.853671375,8.68655Q0.786052375,8.6731,0.7223563749999999,8.646709999999999Q0.658660375,8.62033,0.601335375,8.58203Q0.544010375,8.54373,0.495259375,8.49497Q0.446509375,8.44622,0.408205375,8.3889Q0.369902375,8.33157,0.34351837500000004,8.26788Q0.317135375,8.204180000000001,0.303684375,8.13656Q0.29023437500000004,8.06894,0.29023437500000004,8Q0.29023437500000004,7.93106,0.303684375,7.863440000000001Q0.317135375,7.79582,0.34351837500000004,7.73212Q0.369902375,7.668419999999999,0.408205375,7.6111Q0.446509375,7.55378,0.495259375,7.50502Q0.544010375,7.45627,0.601335375,7.41797Q0.658660375,7.37967,0.7223563749999999,7.35328Q0.786052375,7.3269,0.853671375,7.31345Q0.921290375,7.3,0.990234375,7.3L3.990234375,7.3Q4.114494375,7.3,4.202364375,7.21213Q4.290234375,7.12426,4.290234375,7L4.290234375,4Q4.290234375,3.931056,4.303684375,3.8634370000000002Q4.317134375,3.795818,4.343514375,3.732122Q4.369904375,3.668426,4.408204375,3.611101Q4.446504375,3.553776,4.495254375,3.505025Q4.544014375,3.4562749999999998,4.601334375,3.417971Q4.658654374999999,3.379668,4.722354375,3.353284Q4.786054375,3.326901,4.853674375000001,3.31345Q4.921294375,3.3,4.990234375,3.3Q5.059174375,3.3,5.126794375,3.31345Q5.194414375,3.326901,5.258114375,3.353284Q5.321804375,3.379668,5.379134375,3.417971Q5.436454375,3.4562749999999998,5.485204375,3.505025Q5.533954375,3.553776,5.572264375,3.611101Q5.610564375,3.668426,5.636944375,3.732122Q5.663334375,3.795818,5.676784375,3.8634370000000002Q5.690234375,3.931056,5.690234375,4Z"
          fill-rule="evenodd"
          :fill="fill"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
  <script>
export default {
  name: "ReadMoreSvg",
  props: {
    color: {
      type: String,
      default: "",
    },
    fill: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$el.querySelector("#selected-box").setAttribute("fill", this.color);
    },
  },
};
</script>
<style scoped lang="less">
svg {
  .adapt_pc_widescreen & {
    width: 20px;
    height: 20px;
  }
}
</style>
  